<template>
  <div class="kc_pupop">
    <div class="pupop_form">
      <el-form
        ref="form"
        :model="form"
        label-width="155px"
        label-position="right"
      >
        <div class="top">
          <el-form-item label="化学品:" prop="hxpmc">
            <el-input
              v-model="form.hxpMc"
              disabled
              placeholder=""
              style="width: 226px"
            />
          </el-form-item>
          <el-form-item label="存放仓库:" prop="ckmc">
            <el-input
              v-model="form.ckMc"
              disabled
              style="width: 226px"
            />
          </el-form-item>
          <el-form-item label="保管员:" prop="ckbgy">
            <el-input
              v-model="form.ckbgy"
              disabled
              style="width: 226px"
            />
          </el-form-item>
          <el-form-item label="保管员电话:" prop="ckbgydh">
            <el-input
              v-model="form.ckbgyDh"
              disabled
              style="width: 226px"
            />
          </el-form-item>
          <el-form-item label="库存量:" prop="kcl">
            <el-input
              disabled
              style="width: 226px"
              :value="form.kcl + form.kclDwLabel"
            />
          </el-form-item>
          <el-form-item label="最大仓储量:" prop="zdccl">
            <el-input
              disabled
              style="width: 226px"
              :value="form.ccl + form.cclDwLabel"
            />
          </el-form-item>
          <el-form-item label="初始化库存数量:" prop="cskcsl">
            <el-input
              disabled
              :value="form.cskcSl + form.cskcSldwLabel"
              style="width: 226px"
            />
          </el-form-item>
          <!-- <el-form-item label="登记时间:" prop="djrq">
            <el-input disabled v-model="form.djsj" style="width: 226px"></el-input>
          </el-form-item> -->
        </div>

        <el-form-item label="仓库所在地:" prop="gajg">
          <el-input v-model="form.ckXzqhLabel" disabled />
        </el-form-item>
        <el-form-item label="仓库地址:" prop="ckdz">
          <el-input v-model="form.ckdz" disabled />
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; border-radius: 3px; border-color: #4170ff"
          @click="queding"
        >确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    content: Object
  },
  data() {
    return {
      form: {
        // "id": "zzyzd202111272203130000000000001",
        // "ckId": "zzyzd202111271052220000000000001",//仓库主键
        // "hxpBm": "201",//化学品编码
        // "kcl": 500000,//库存量
        // "kclDw": "2",//库存量单位
        // "kclDwLabel": "千克",//库存量单位Label
        // "hxpMc": "苯乙酸",//化学品
        // "ckMc": "测试仓库",//仓库名称
        // "ckbgy": "仓管员1",//保管员
        // "ckbgyDh": "18353522009",//保管员电话
        // "cskcSl": 500,//初始库存数量
        // "cskcSldwLabel": "千克",//初始库存数量单位Label
        // "djsj": "2021-11-27",//初始库存登记时间
        // "ccl": 124.22,//仓储量
        // "cclDwLabel": "吨",//仓储量单位Label
        // "ckXzqhLabel": "北京市/市辖区/西城区",//行政区划Label
        // "ckdz": "四川哈哈哈"//仓库地址
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.form = this.content
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    queding() {
      this.$parent.$parent.dialogVisible = false
    }
  }
}
</script>
<style scoped lang='less'>
.kc_pupop {
  .top {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
